import { createAsyncThunk } from "@reduxjs/toolkit";
import { retrieveBanksBankIdGet } from "../../../shared/api/services.gen.js";
import ApiService from "../../../shared/services/ApiService.js";
import { name } from "../config/name.js";
import { selectEntities } from "./selectors/selectSlice.js";
const fetchBanks = createAsyncThunk(`${name}/fetchBanks`, async (bankIds, api) => {
  const state = api.getState();
  const { clientId } = state.config;
  const apiClient = ApiService.getInstance().client;
  const bankEntities = selectEntities(state);
  const existingBanks = [];
  const promises = [];
  const uniqueBankIds = [...new Set(bankIds)];
  uniqueBankIds.forEach((bankId) => {
    const existingBank = bankEntities[bankId];
    if (existingBank) {
      existingBanks.push(existingBank);
      return;
    }
    const promise = retrieveBanksBankIdGet({
      client: apiClient,
      headers: {
        "X-Client-Id": clientId
      },
      path: { bank_id: bankId }
    }).then((response) => {
      if (!response.data) {
        throw new Error(`Ошибка, банк (id = "${bankId}") не найден!`);
      }
      return response.data;
    });
    promises.push(promise);
  });
  const newBanks = await Promise.all(promises);
  return [...existingBanks, ...newBanks];
});
export {
  fetchBanks
};
